import type { Garage, Organization, Service } from "@App/types";
import { ServiceHasCustomImagePlaceholder } from "@App/utils/conditionals/services";
import type React from "react";

type Props = {
  garage: Garage;
  service?: Service;
  url: string;
  organization: Organization;
  bookable: boolean;
};

export const GarageCoverImage: React.FC<Props> = ({
  garage,
  service,
  url,
  organization,
  bookable,
}) => {
  if (!bookable) return null;

  if (garage.cover_image) {
    return (
      <img
        src={`${url}/storage/${garage.cover_image}`}
        className="rounded-t lg:rounded w-full h-auto"
        alt=""
      />
    );
  }

  return (
    <div className="flex items-center justify-center text-center text-lg text-neutral-700 font-serif font-bold rounded-t lg:rounded bg-neutral-300 w-full h-full min-h-[250px] lg:min-h-min p-4">
      {service && ServiceHasCustomImagePlaceholder(service) ? (
        <span>
          {service?.pivot?.display_image_placeholder?.replace(
            "%ORGANIZATION%",
            organization.name ?? "",
          )}
        </span>
      ) : (
        <>
          {organization.name}
          <br />
          Service Location
        </>
      )}
    </div>
  );
};
